module.exports = __webpack_public_path__ + "img/AT0000001449915.9173e74a.png";